export enum RiskRepositoryCode {
  CREDIT,
  LEGAL,
  LIQUIDITY,
  MARKET,
  OPERATIONAL,
  PRICING_AND_UNDERWRITING,
  REPUTATIONAL,
  RESERVING,
  STRATEGIC
}
